import React, { createContext, useContext } from 'react'

const MembershipJourneyContext = createContext()

export const MembershipJourneyProvider = ({ value, children }) => {
  return (
    <MembershipJourneyContext.Provider value={value}>
      {children}
    </MembershipJourneyContext.Provider>
  )
}

export const useMembershipJourneyContext = () => {
  const context = useContext(MembershipJourneyContext)
  if (!context) {
    throw new Error('useMembershipJourneyContext must be used within a MembershipJourneyProvider')
  }
  return context
}

export default MembershipJourneyContext

